export default __webpack_public_path__ + "static/media/Reception.ee92eda9.jpg";